module.exports = __webpack_public_path__ + "img/tabler_send.306e6205.svg";